
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8Qp3O", function(module, exports) {

$parcel$export(module.exports, "DummyConfluenceLinkCoUse", () => $aaeb14ed9fafe33e$export$cab8aacdc34ef03d);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $duIk1 = parcelRequire("duIk1");

var $2snjz = parcelRequire("2snjz");

var $85YxZ = parcelRequire("85YxZ");

var $bTT6v = parcelRequire("bTT6v");

var $bYK7l = parcelRequire("bYK7l");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8WpNU = parcelRequire("8WpNU");

var $ciPDq = parcelRequire("ciPDq");

var $f7CQF = parcelRequire("f7CQF");

var $hxqfC = parcelRequire("hxqfC");

var $kQwJI = parcelRequire("kQwJI");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");

var $g5X3G = parcelRequire("g5X3G");

var $90yGq = parcelRequire("90yGq");

var $9OXo1 = parcelRequire("9OXo1");

var $dCm1o = parcelRequire("dCm1o");

var $ba9qP = parcelRequire("ba9qP");

var $dIho9 = parcelRequire("dIho9");

var $hBjID = parcelRequire("hBjID");

var $7PZLB = parcelRequire("7PZLB");

var $g5LTL = parcelRequire("g5LTL");

var $kRpPw = parcelRequire("kRpPw");

var $5E5Kv = parcelRequire("5E5Kv");

var $c6paD = parcelRequire("c6paD");

var $3K0KG = parcelRequire("3K0KG");

var $3sqIb = parcelRequire("3sqIb");

var $eov6A = parcelRequire("eov6A");

var $4xVfK = parcelRequire("4xVfK");

var $bFdMv = parcelRequire("bFdMv");
const $aaeb14ed9fafe33e$export$d0df311f9d30eda4 = ({ issueType: issueType, onAddButtonClicked: onAddButtonClicked, projectName: projectName, shouldShowHeading: shouldShowHeading, hasActivatedConfluenceWithinFourteenDays: hasActivatedConfluenceWithinFourteenDays, onLinkPage: onLinkPage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const template = (0, $5uXOq.useMemo)(()=>(0, $7PZLB.getConfluencePlaceholderTemplate)(issueType), [
        issueType
    ]);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { isDismissed: isDismissed, onDismissAd: onDismissAd } = (0, $ba9qP.useAdControlsFunctionality)({
        userPropertyPlaceholderTemplate: (0, $hBjID.USER_PROPERTY_DUMMY_LINK_CO_USE // change this
        )
    });
    const { isCoUseEligible: isCoUseEligible } = (0, $eov6A.useIsCoUseEligible)({
        template: template,
        isDismissed: isDismissed,
        hasActivatedConfluenceWithinFourteenDays: hasActivatedConfluenceWithinFourteenDays
    });
    const showDummyLink = !!template && isCoUseEligible;
    (0, $5uXOq.useEffect)(()=>{
        if (showDummyLink) (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}));
    }, [
        showDummyLink,
        createAnalyticsEvent
    ]);
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const accountId = (0, $90yGq.useAccountId)() || '';
    const onPublish = (0, $5uXOq.useCallback)(async ()=>{
        try {
            await (0, $89SaW.setUserProperties)(accountId, (0, $hBjID.USER_PROPERTY_DUMMY_LINK_CO_USE), JSON.stringify(true));
        } catch  {
            (0, $jcw0u.default)({
                meta: {
                    id: 'onPublishEmbeddedPagePlaceholderTemplateCoUse',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'starburst'
                },
                error: new Error('Unable to update user property for placeholder template co use')
            });
        }
    }, [
        accountId
    ]);
    const epModalEntryPointContainer = (0, $kRpPw.useDraftEpModal)({
        onPublish: onPublish,
        ...(0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep') && {
            linkConfluencePage: onLinkPage
        }
    });
    const { isEpModalOpen: isEpModalOpen, setIsEpModalOpen: setIsEpModalOpen, setActivePageUrl: setActivePageUrl, isLoading: isLoading, setIsLoading: setIsLoading } = (0, $g5LTL.useConfluenceDummyLinkContext)();
    const onClickPlaceholderTemplate = (0, $5uXOq.useCallback)(async ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'confluencePlaceholderTemplateCoUse');
        try {
            setIsLoading(true);
            const space = await (0, $4xVfK.createSpaceForProjectName)(projectName || '');
            const spaceKey = space?.key;
            if (!spaceKey || !template) return;
            if (space?.spaceCreated) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'spaceWithProjectName created');
            const result = await (0, $5E5Kv.createConfluenceDraft)(cloudId, spaceKey, template.blueprintModuleCompleteKey);
            if (result) {
                const activePageUrl = (0, $c6paD.getActivePageUrl)(result.contentId, result.draftShareId, spaceKey);
                setActivePageUrl(activePageUrl);
                setIsEpModalOpen(true);
            }
        } catch  {
            setIsLoading(false);
            showFlag({
                messageId: 'issue-view-base.content.confluence-placeholder-template-experiment.confluence-dummy-link.experiments.placeholder-template-co-use.show-flag.error.page-load-fail',
                messageType: 'transactional',
                type: 'error',
                isAutoDismiss: true,
                title: formatMessage((0, $3K0KG.default).pageLoadFailFlagTitle),
                description: formatMessage((0, $3K0KG.default).pageLoadFailFlagDescription)
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'onClickPlaceholderTemplateCoUse',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'starburst'
                }
            });
        }
    }, [
        cloudId,
        projectName,
        setActivePageUrl,
        setIsEpModalOpen,
        template,
        formatMessage,
        showFlag,
        setIsLoading,
        createAnalyticsEvent
    ]);
    const onClickPlusButton = (0, $5uXOq.useCallback)(async ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'linkConfluencePage');
        onAddButtonClicked();
    }, [
        createAnalyticsEvent,
        onAddButtonClicked
    ]);
    if (!showDummyLink) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEpModalOpen && epModalEntryPointContainer, shouldShowHeading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.DummySectionHeading), {
        "data-testid": (0, $bFdMv.TEST_IDS).header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.DummySectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7CQF.SectionHeadingTitle), null, formatMessage((0, $3K0KG.default).newHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.DummySectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dIho9.default), {
        menuButtonTestId: (0, $bFdMv.TEST_IDS).adMenuButton,
        onClickDismiss: onDismissAd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WpNU.default), {
        label: "link-a-confluence-page",
        onClick: onClickPlusButton
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.DummyGroupContainer), {
        "data-testid": (0, $bFdMv.TEST_IDS).mainContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ciPDq.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        className: (0, $bwpsq.default)([
            "_qtt8glyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duIk1.default), {
        appearance: "subtle",
        shouldFitContainer: true,
        spacing: "none",
        onClick: onClickPlaceholderTemplate,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _4t3i1wug _1nrm18uv _1a3b18uv _5bd618uv _1ydc18uv _c2waglyw _4fprglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _xatrnqa1 _1726nqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _4cvxr3uz _1llwglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.CardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.LeftWrapper), null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2snjz.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bTT6v))),
        label: "",
        appearance: "blueBold",
        shape: "square",
        size: "16"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85YxZ.default), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.StyledTemplateName), null, formatMessage(template.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.RightWrapper), null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _o5721q9c _1bto1l2s"
        ])
    }, formatMessage((0, $3K0KG.default).loadingTemplate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYK7l.default), {
        size: "small"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sqIb.TryLozenge), {
        appearance: "new"
    }, formatMessage((0, $3K0KG.default).tryTemplateLozenge))))))))));
};
const $aaeb14ed9fafe33e$var$mapDispatchToProps = (dispatch)=>({
        onLinkPage: (link, analyticsEvent)=>dispatch((0, $kQwJI.createConfluencePageLinkRequest)((0, $g5X3G.toHref)(link), analyticsEvent))
    });
const $aaeb14ed9fafe33e$var$mapStateToProps = ()=>({});
const $aaeb14ed9fafe33e$var$DummyConfluenceLinkCoUseWithReduxDispatchProps = (0, $hxqfC.connect)($aaeb14ed9fafe33e$var$mapStateToProps, $aaeb14ed9fafe33e$var$mapDispatchToProps)($aaeb14ed9fafe33e$export$d0df311f9d30eda4);
const $aaeb14ed9fafe33e$export$cab8aacdc34ef03d = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep'), $aaeb14ed9fafe33e$var$DummyConfluenceLinkCoUseWithReduxDispatchProps, $aaeb14ed9fafe33e$export$d0df311f9d30eda4);
const $aaeb14ed9fafe33e$var$buttonStyle = null;
const $aaeb14ed9fafe33e$var$LoadingTemplate = null;
const $aaeb14ed9fafe33e$var$listStyle = null;

});
parcelRegister("ba9qP", function(module, exports) {

$parcel$export(module.exports, "useAdControlsFunctionality", () => $f93db2d9bd9d155e$export$200d7892ced015e6);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");

var $90yGq = parcelRequire("90yGq");

var $7PZLB = parcelRequire("7PZLB");
const $f93db2d9bd9d155e$var$AD_CONTROLS_FETCH_ERROR = 'adControlsFetchError';
const $f93db2d9bd9d155e$export$200d7892ced015e6 = ({ userPropertyPlaceholderTemplate: userPropertyPlaceholderTemplate })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const accountId = (0, $90yGq.useAccountId)() || '';
    const [isDismissed, setIsDismissed] = (0, $5uXOq.useState)(true);
    const fetchUserProperties = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const res = await (0, $7PZLB.getHasDismissedConfluencePlaceholderTemplate)(accountId, userPropertyPlaceholderTemplate);
            setIsDismissed(!!res);
        } catch (error) {
            setIsDismissed(true);
            let adControlsError;
            if (error instanceof (0, $jJZqs.default)) adControlsError = new Error(`Fetch Error, failed to get user property: ${userPropertyPlaceholderTemplate}, status code was: ${error.statusCode}`);
            else adControlsError = new Error(`Failed to get user property: ${userPropertyPlaceholderTemplate}`, {
                cause: error
            });
            (0, $jcw0u.default)({
                meta: {
                    id: $f93db2d9bd9d155e$var$AD_CONTROLS_FETCH_ERROR,
                    packageName: 'jiraIssueViewBase',
                    teamName: 'starburst'
                },
                error: adControlsError
            });
        }
    }, [
        accountId,
        userPropertyPlaceholderTemplate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (accountId !== '') fetchUserProperties();
    }, [
        accountId,
        fetchUserProperties
    ]);
    const clickedButtonBaseEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const onDismissAd = (0, $5uXOq.useCallback)(async ()=>{
        await (0, $89SaW.setUserProperties)(accountId, userPropertyPlaceholderTemplate, JSON.stringify(true));
        setIsDismissed(true);
        (0, $8zOmE.fireUIAnalytics)(clickedButtonBaseEvent, 'notInterested', {
            panelName: 'crossflow-confluence-placeholder-template'
        });
    }, [
        accountId,
        userPropertyPlaceholderTemplate,
        clickedButtonBaseEvent
    ]);
    return {
        isDismissed: isDismissed,
        onDismissAd: onDismissAd
    };
};

});

parcelRegister("dIho9", function(module, exports) {

$parcel$export(module.exports, "default", () => $312f32976491e469$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $duIk1 = parcelRequire("duIk1");

var $kfIGo = parcelRequire("kfIGo");

var $flvYJ = parcelRequire("flvYJ");

var $hCfTW = parcelRequire("hCfTW");

var $8cc7O = parcelRequire("8cc7O");
var $ZY1kc = parcelRequire("ZY1kc");
var $i79po = parcelRequire("i79po");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");

var $jCTxx = parcelRequire("jCTxx");

var $4D4Ym = parcelRequire("4D4Ym");
const $312f32976491e469$var$AdControls = ({ onClickDismiss: onClickDismiss, menuButtonTestId: menuButtonTestId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8cc7O.default), {
        itemId: "placeholder-template-ad-controls",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCfTW.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duIk1.default), {
                ...props,
                testId: menuButtonTestId,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($flvYJ))), {
                    color: "currentColor",
                    label: "more",
                    spacing: "none",
                    LEGACY_size: "small"
                }),
                ref: triggerRef,
                interactionName: "auto-generated.jira-issue-view-base.content.confluence-placeholder-template-experiment.common.ad-controls.button"
            }))
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZY1kc.default), {
            ...props,
            flagProps: {
                title: formatMessage((0, $jCTxx.default).dismissFlagTitle),
                description: formatMessage((0, $jCTxx.default).dismissFlagDescription)
            },
            onClick: onClickDismiss
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i79po.default), {
            ...props,
            modalProps: {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfIGo.default), {
                    size: "medium"
                }, formatMessage((0, $jCTxx.default).reasonsModalTitle)),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                    sourceName: "adControlsReasons",
                    sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4D4Ym.default), null))
            }
        })));
};
var $312f32976491e469$export$2e2bcd8739ae039 = $312f32976491e469$var$AdControls;

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("4D4Ym", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7bdc606e4ceff0$export$2e2bcd8739ae039);
/* reasons-modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $duIk1 = parcelRequire("duIk1");

var $1lQB4 = parcelRequire("1lQB4");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");

var $hBjID = parcelRequire("hBjID");

var $jCTxx = parcelRequire("jCTxx");
const $ed7bdc606e4ceff0$var$AdControlsReasonsModal = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent
    ]);
    const clickedLinkBaseEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    const onClickPrivacyPolicy = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
    }, [
        clickedLinkBaseEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $jCTxx.default).reasonsModalExplanation, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1lQB4.default), {
                as: "strong"
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed7bdc606e4ceff0$var$BulletPoints, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $jCTxx.default).reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", null, formatMessage((0, $jCTxx.default).reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $duIk1.default), {
        appearance: "link",
        spacing: "none",
        href: (0, $hBjID.DATA_PRIVACY_LINK),
        target: "_blank",
        onClick: onClickPrivacyPolicy,
        interactionName: "auto-generated.jira-issue-view-base.content.confluence-placeholder-template-experiment.common.ad-controls.button"
    }, formatMessage((0, $jCTxx.default).privacyPolicy)));
};
var $ed7bdc606e4ceff0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ed7bdc606e4ceff0$var$AdControlsReasonsModal;
const $ed7bdc606e4ceff0$var$BulletPoints = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrutpp",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kRpPw", function(module, exports) {

$parcel$export(module.exports, "useDraftEpModal", () => $c0ca9159faa1894a$export$d47a07158f47da);

var $g5LTL = parcelRequire("g5LTL");

var $4vCny = parcelRequire("4vCny");
const $c0ca9159faa1894a$export$d47a07158f47da = ({ onEmbeddedContentAction: onEmbeddedContentAction, onPublish: onPublish, linkConfluencePage: linkConfluencePage })=>{
    const { isEpModalOpen: isEpModalOpen, activePageUrl: activePageUrl, setIsEpModalOpen: setIsEpModalOpen, setIsLoading: setIsLoading } = (0, $g5LTL.useConfluenceDummyLinkContext)();
    const { epModalEntryPointContainer: epModalEntryPointContainer } = (0, $4vCny.useDraftEmbeddedPageModalEntryPoint)({
        isEpModalOpen: isEpModalOpen,
        setIsEpModalOpen: setIsEpModalOpen,
        activePageUrl: activePageUrl,
        embeddedConfluenceSource: 'jswIssueView',
        onEmbeddedContentAction: onEmbeddedContentAction,
        onPublish: onPublish,
        setIsLoading: setIsLoading,
        linkConfluencePage: linkConfluencePage
    });
    return epModalEntryPointContainer;
};

});
parcelRegister("4vCny", function(module, exports) {

$parcel$export(module.exports, "useDraftEmbeddedPageModalEntryPoint", () => $3509afe14e06bec7$export$d575cf302237c037);

var $5uXOq = parcelRequire("5uXOq");

var $50LfS = parcelRequire("50LfS");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $fvjUj = parcelRequire("fvjUj");

var $dELl0 = parcelRequire("dELl0");
const $3509afe14e06bec7$export$d575cf302237c037 = ({ isEpModalOpen: isEpModalOpen, activePageUrl: activePageUrl, setIsEpModalOpen: setIsEpModalOpen, embeddedConfluenceSource: embeddedConfluenceSource, onEmbeddedContentAction: onEmbeddedContentAction, onPublish: onPublish, setIsLoading: setIsLoading, linkConfluencePage: linkConfluencePage })=>{
    const parentProduct = (0, $fvjUj.useParentProduct)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $dELl0.draftEmbeddedPageModalEntrypoint), {});
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsLoading(false);
        setIsEpModalOpen(false);
        entryPointActions.unload();
    }, [
        setIsEpModalOpen,
        entryPointActions,
        setIsLoading
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            ...(0, $4R6GH.fg)('jira_issue_view_expand_modeless_ep') && {
                linkConfluencePage: linkConfluencePage
            },
            hasFooterLogo: false,
            isOpen: true,
            onClose: onClose,
            parentProduct: parentProduct,
            url: activePageUrl,
            embeddedConfluenceSource: embeddedConfluenceSource,
            spaceKey: (0, $50LfS.parseUrl)(activePageUrl)?.spaceKey,
            contentId: (0, $50LfS.parseUrl)(activePageUrl)?.contentId,
            onPageAction: onEmbeddedContentAction,
            allowedFeatures: {
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-comments',
                    'page-reactions',
                    'inline-comments',
                    'non-licensed-share'
                ]
            },
            onPublish: onPublish
        }), [
        onClose,
        parentProduct,
        activePageUrl,
        embeddedConfluenceSource,
        onEmbeddedContentAction,
        onPublish,
        linkConfluencePage
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (isEpModalOpen) entryPointActions.load();
    }, [
        isEpModalOpen,
        entryPointActions
    ]);
    return {
        epModalEntryPointContainer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "epModalEntrypointContainer",
            packageName: "jiraIssueViewBase",
            teamName: "starburst",
            runtimeProps: runtimeProps
        })
    };
};

});


parcelRegister("5E5Kv", function(module, exports) {

$parcel$export(module.exports, "createConfluenceDraft", () => $def0f63aa9c7ee85$export$35a28ef15d43eade);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $eIwq1 = parcelRequire("eIwq1");
const $def0f63aa9c7ee85$export$35a28ef15d43eade = async (cloudId, spaceKey, blueprintModuleCompleteKey)=>{
    try {
        const [blueprint] = await Promise.all([
            (0, $eIwq1.getBlueprint)(cloudId, spaceKey, blueprintModuleCompleteKey)
        ]);
        const response = await (0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/content/blueprint/${blueprintModuleCompleteKey}/instance`, {
            method: 'POST',
            body: JSON.stringify({
                content: {
                    type: 'page',
                    status: 'draft',
                    space: {
                        key: spaceKey
                    },
                    metadata: {
                        properties: {
                            editor: {
                                value: 'v2'
                            }
                        },
                        frontend: {
                            embedded: true
                        }
                    }
                },
                contentBlueprintSpec: {
                    context: {
                        spaceKey: spaceKey
                    },
                    blueprintId: blueprint.contentBlueprintId
                }
            })
        });
        return {
            contentId: response.content.id,
            draftShareId: response.content._links.editui?.match(/draftShareId=(.*?)(#|&|$)/)?.[1]
        };
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'createConfluenceDraft',
                packageName: 'jiraIssueViewBase',
                teamName: 'starburst'
            },
            error: {
                name: 'error',
                message: `Fetching blueprints succeeded, but blueprint: ${blueprintModuleCompleteKey} was not found for space: ${spaceKey}`
            }
        });
        return null;
    }
};

});
parcelRegister("eIwq1", function(module, exports) {

$parcel$export(module.exports, "getBlueprint", () => $88fbe32b6bbe4062$export$ebbc6f9d15c71fb0);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");
const $88fbe32b6bbe4062$export$ebbc6f9d15c71fb0 = async (cloudId, spaceKey, blueprintModuleCompleteKey)=>{
    let blueprints;
    const url = `/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/blueprints/web-items?spaceKey=${spaceKey}`;
    try {
        blueprints = await (0, $7f4tk.default)(url);
        const found = blueprints.find((blueprint)=>blueprint.blueprintModuleCompleteKey === blueprintModuleCompleteKey);
        if (!found) throw new Error(`Fetching blueprints succeeded, but blueprint: ${blueprintModuleCompleteKey} was not found for space: ${spaceKey}`);
        return found;
    } catch (error) {
        (0, $jcw0u.default)({
            meta: {
                id: 'createConfluenceDraftGetBlueprint',
                packageName: 'jiraIssueViewBase',
                teamName: 'starburst'
            },
            error: {
                name: 'error',
                message: `Unknown error calling getBlueprint for space: ${spaceKey}`
            }
        });
        throw error || new Error(`Error calling ${url}`);
    }
};

});


parcelRegister("c6paD", function(module, exports) {

$parcel$export(module.exports, "getActivePageUrl", () => $7b74ce3b2ea8af8e$export$9c15ab9e1732ad28);
const $7b74ce3b2ea8af8e$export$9c15ab9e1732ad28 = (contentId, draftShareId, spaceKey)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    `${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit-v2/${contentId}/?draftShareId=${draftShareId}`;

});

parcelRegister("3sqIb", function(module, exports) {

$parcel$export(module.exports, "DummySectionHeading", () => $1ed92604df5e6e84$export$1c684df08303aef9);
$parcel$export(module.exports, "InfoButton", () => $1ed92604df5e6e84$export$10d4b9c1046c21df);
$parcel$export(module.exports, "TryLozenge", () => $1ed92604df5e6e84$export$ff5672c4664546a);
$parcel$export(module.exports, "StyledLink", () => $1ed92604df5e6e84$export$9048d548939551ee);
$parcel$export(module.exports, "RightWrapper", () => $1ed92604df5e6e84$export$8e62e599821d99ec);
$parcel$export(module.exports, "LeftWrapper", () => $1ed92604df5e6e84$export$c3d2343a748f64d3);
$parcel$export(module.exports, "DummyGroupContainer", () => $1ed92604df5e6e84$export$8959dc0d4392a216);
$parcel$export(module.exports, "CardWrapper", () => $1ed92604df5e6e84$export$6aa22a823032b784);
$parcel$export(module.exports, "StyledTemplateName", () => $1ed92604df5e6e84$export$c76ce79facc3b67b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $duIk1 = parcelRequire("duIk1");

var $eiJsc = parcelRequire("eiJsc");

var $41j30 = parcelRequire("41j30");

var $hjSnd = parcelRequire("hjSnd");
const $1ed92604df5e6e84$export$1c684df08303aef9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSnd.FieldHeadingIconsVisibility), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulph8dc _1e0c1txw _4cvr1h6o _1n261q9c _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$10d4b9c1046c21df = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $duIk1.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz41tcg _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$ff5672c4664546a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $eiJsc.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$9048d548939551ee = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $41j30.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$8e62e599821d99ec = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulph8dc _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$c3d2343a748f64d3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulph8dc _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz1fxt _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$8959dc0d4392a216 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxidpf _otyru2gc _18u0idpf _u5f3v77o",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$6aa22a823032b784 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _n7zlzgxb _16qsglyw _bfhk1w7a _ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7 _19pkidpf _2hwxv77o _otyridpf _18u0v77o _1e0c1txw _1tke1ylp _1bah1yb4 _4cvr1h6o _1wpz1fhb _y7iw3acm _9oik18uv _1bnxglyw _jf4cnqa1 _irr3166n _d0altlke",
            __cmplp.className
        ])
    });
});
const $1ed92604df5e6e84$export$c76ce79facc3b67b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _19pkze3t _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eov6A", function(module, exports) {

$parcel$export(module.exports, "useIsCoUseEligible", () => $992095c98d4c15c0$export$9d3b05f7271c5614);

var $5uXOq = parcelRequire("5uXOq");

var $cyA39 = parcelRequire("cyA39");

var $8zOmE = parcelRequire("8zOmE");
var $d22NM = parcelRequire("d22NM");

var $9OXo1 = parcelRequire("9OXo1");

var $bFdMv = parcelRequire("bFdMv");
const $992095c98d4c15c0$export$9d3b05f7271c5614 = ({ template: template, isDismissed: isDismissed, hasActivatedConfluenceWithinFourteenDays: hasActivatedConfluenceWithinFourteenDays })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $d22NM.useAnalyticsEvents)();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    const tenantHasConfluence = licensedProducts?.confluence === true;
    const { hasAccess: hasAccess } = (0, $cyA39.useUserHasConfluenceAccess)();
    const isCoUseEligible = !!template && tenantHasConfluence && hasAccess && !isDismissed && hasActivatedConfluenceWithinFourteenDays;
    (0, $5uXOq.useEffect)(()=>{
        if (!isCoUseEligible) return;
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'placeholderTemplateCoUse exposed', {
            flagKey: (0, $bFdMv.PLACEHOLDER_TEMPLATE_CO_USE_EXPERIMENT_ID)
        });
    }, [
        createAnalyticsEvent,
        isCoUseEligible
    ]);
    return {
        isCoUseEligible: isCoUseEligible
    };
};

});
parcelRegister("bFdMv", function(module, exports) {

$parcel$export(module.exports, "PLACEHOLDER_TEMPLATE_CO_USE_EXPERIMENT_ID", () => $228bc8e90a6b18c9$export$4618cb4452cd454d);
$parcel$export(module.exports, "TEST_IDS", () => $228bc8e90a6b18c9$export$a2b4f255152a6585);

var $6s1PB = parcelRequire("6s1PB");
const $228bc8e90a6b18c9$export$4618cb4452cd454d = 'confluence_template_placeholder';
const $228bc8e90a6b18c9$export$a2b4f255152a6585 = {
    addLinkButton: 'issue-view-common-views.button.icon-button.link-a-confluence-page',
    mainContainer: 'placeholder-template-main-container',
    header: 'placeholder-template-header',
    adMenuButton: 'placeholder-template-ad-menu-button'
};
const $228bc8e90a6b18c9$export$48d5df5d7b3279cd = ()=>{
    // eslint-disable-next-line jira/ff/inline-usage
    const exp = (0, $6s1PB.expVal)('confluence_template_placeholder', 'cohort', 'not-enrolled');
    return exp;
};

});


parcelRegister("4xVfK", function(module, exports) {

$parcel$export(module.exports, "createSpaceForProjectName", () => $4d5db32a4c655856$export$97efe9503a0cb74e);

var $8W0FU = parcelRequire("8W0FU");
const $4d5db32a4c655856$export$97efe9503a0cb74e = async (projectName)=>{
    if (!projectName) return;
    const key = await (0, $8W0FU.hasSpaceWithProjectName)(projectName);
    if (key) return {
        key: key,
        spaceCreated: false
    };
    const spaceKey = (0, $8W0FU.spaceNameToSpaceKey)(projectName);
    if (!spaceKey) return;
    const [blankSpaceBlueprintId, generatedSpaceKey] = await Promise.all([
        (0, $8W0FU.getBlankSpaceBlueprintId)(),
        (0, $8W0FU.generateSpaceKey)(spaceKey)
    ]);
    if (!generatedSpaceKey || !blankSpaceBlueprintId) return;
    const data = await (0, $8W0FU.createSpace)({
        spaceName: projectName,
        spaceKey: generatedSpaceKey,
        spaceBlueprintId: blankSpaceBlueprintId
    });
    const updatedData = {
        ...data,
        spaceCreated: true
    };
    return updatedData;
};

});
parcelRegister("8W0FU", function(module, exports) {

$parcel$export(module.exports, "hasSpaceWithProjectName", () => $c9a3232a642a31bf$export$6ae10b8aab17ec24);
$parcel$export(module.exports, "getBlankSpaceBlueprintId", () => $c9a3232a642a31bf$export$9c5e9de76230b5cd);
$parcel$export(module.exports, "spaceNameToSpaceKey", () => $c9a3232a642a31bf$export$cc6b2f7942bbb840);
$parcel$export(module.exports, "generateSpaceKey", () => $c9a3232a642a31bf$export$a7109cd91ae8e809);
$parcel$export(module.exports, "createSpace", () => $c9a3232a642a31bf$export$cdf31d8a98a8b33);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $hQiXg = parcelRequire("hQiXg");
async function $c9a3232a642a31bf$export$6ae10b8aab17ec24(projectName) {
    try {
        const api = '/wiki/api/v2/spaces';
        const spaces = await (0, $eusud.performGetRequest)(api);
        const spaceKey = spaces.results?.find((space)=>space.name === projectName)?.key || '';
        return spaceKey;
    } catch  {
        (0, $jcw0u.default)({
            meta: {
                id: 'hasSpaceWithProjectName',
                packageName: 'jiraIssueViewBase',
                teamName: 'starburst'
            }
        });
        throw new Error('Failed to fetch Confluence spaces');
    }
}
async function $c9a3232a642a31bf$export$9c5e9de76230b5cd() {
    try {
        const api = '/wiki/rest/create-dialog/1.0/space-blueprint/dialog/web-items';
        const spaceBlueprints = await (0, $eusud.performGetRequest)(api);
        const blankSpaceBlueprintId = spaceBlueprints.find((spaceBlueprint)=>spaceBlueprint.blueprintModuleCompleteKey === (0, $hQiXg.BlueprintCompleteKey).BLANK_SPACE)?.contentBlueprintId || '';
        return blankSpaceBlueprintId;
    } catch  {
        (0, $jcw0u.default)({
            meta: {
                id: 'getBlankSpaceBlueprintId',
                packageName: 'jiraIssueViewBase',
                teamName: 'starburst'
            }
        });
        throw new Error('Failed to get blank space blueprintId');
    }
}
function $c9a3232a642a31bf$export$cc6b2f7942bbb840(name) {
    if (!name) return null;
    const words = name.split(' ').map((word)=>word.replace(/[^a-zA-Z0-9]+/g, '')).filter((word)=>word);
    if (!words) return null;
    let key;
    if (words.length > 1) {
        const initials = words.map((word)=>word[0]);
        key = initials.join('').toUpperCase();
    } else key = words[0];
    if (!key) return null;
    return key.length > 10 ? key.substring(0, 10) : key;
}
async function $c9a3232a642a31bf$export$a7109cd91ae8e809(spaceName) {
    if (!spaceName) return '';
    try {
        const api = `/wiki/rest/onboarding/1/space/generate?key=${spaceName}`;
        const { key: key } = await (0, $eusud.performGetRequest)(api);
        // fire track event for successful key generation, implementing in STAR-1248
        return key;
    } catch  {
        (0, $jcw0u.default)({
            meta: {
                id: 'generateSpaceKey',
                packageName: 'jiraIssueViewBase',
                teamName: 'starburst'
            }
        });
        throw new Error('Failed to generate a space key');
    }
}
async function $c9a3232a642a31bf$export$cdf31d8a98a8b33({ spaceName: spaceName, spaceKey: spaceKey, spaceBlueprintId: spaceBlueprintId }) {
    try {
        const api = '/wiki/rest/create-dialog/1.0/space-blueprint/create-space?favorite=true';
        const data = await (0, $eusud.performPostRequest)(api, {
            body: JSON.stringify({
                context: {
                    ContentPageTitle: spaceName,
                    members: ''
                },
                name: spaceName,
                spaceKey: spaceKey,
                spaceBlueprintId: spaceBlueprintId,
                description: ''
            }),
            headers: {
                'Content-Type': (0, $hQiXg.MediaType).JSON,
                Accept: (0, $hQiXg.MediaType).JSON
            }
        });
        // fire track event for successful space creation, implementing in STAR-1248
        return data;
    } catch  {
        (0, $jcw0u.default)({
            meta: {
                id: 'createSpace',
                packageName: 'jiraIssueViewBase',
                teamName: 'starburst'
            }
        });
        throw new Error('Failed to create a JSW project name Confluence space');
    }
}

});
parcelRegister("hQiXg", function(module, exports) {

$parcel$export(module.exports, "BlueprintCompleteKey", () => $cd1e67391b2784ac$export$d882c9caa413f34e);
$parcel$export(module.exports, "MediaType", () => $cd1e67391b2784ac$export$483c11740a902fcd);
const $cd1e67391b2784ac$export$d882c9caa413f34e = {
    BLANK_SPACE: 'com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blank-space-blueprint'
};
const $cd1e67391b2784ac$export$483c11740a902fcd = {
    JSON: 'application/json',
    X_WWW_FORM_URLENCODED: 'application/x-www-form-urlencoded'
};

});





//# sourceMappingURL=async-dummy-confluence-link-with-conf.27056fc5.js.map
